function Hotjar() {
  document.write(`
    <script async defer>
      (function (h, o, t, j, a, r) {
        h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) };
        h._hjSettings = { hjid: 872518, hjsv: 6 };
        a = o.getElementsByTagName('head')[0];
        r = o.createElement('script'); r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
      })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    </script>
  `);
}

function GTAG() {
  // import js
  const gtagJS = document.createElement('script');
  gtagJS.src = 'https://www.googletagmanager.com/gtag/js?id=AW-444585266';
  document.getElementsByTagName('head')[0].appendChild(gtagJS);

  // script
  const gtagScript = document.createElement('script');
  gtagScript.innerHTML = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'AW-444585266');`;
  document.getElementsByTagName('head')[0].appendChild(gtagScript);
}

function Navegg() {
  const naveggScript = document.createElement('script');
  naveggScript.type = 'text/javascript';
  naveggScript.id = 'navegg';
  naveggScript.innerHTML = `(function(n,v,g){o='Navegg';if(!n[o]){
    a=v.createElement('script');a.src=g;b=document.getElementsByTagName('script')[0];
    b.parentNode.insertBefore(a,b);n[o]=n[o]||function(parms){ n[o].q=n[o].q||[];n[o].q.push([this, parms])};} })
    (window, document, 'https://tag.navdmp.com/universal.min.js');
    window.naveggReady = window.naveggReady||[];
    window.nvg52489 = new Navegg({
    acc: 52489
    });`;
  document.getElementsByTagName('head')[0].appendChild(naveggScript);
}

function GoogleTagManager() {
  const gtmScript = document.createElement('script');
  const queriedHead = document.getElementsByTagName('head')[0];
  gtmScript.type = 'text/javascript';
  gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-NDC5CJT');`;
  queriedHead.insertBefore(gtmScript, queriedHead.firstChild);
}

function Retargeting() {
  const script = document.createElement('script');
  const bodyElement = document.getElementsByTagName('body')[0];
  script.async = true;
  script.src = '//pixel.mathtag.com/event/js?mt_id=1348891&mt_adid=214264&mt_exem=&mt_excl=&v1=&v';
  bodyElement.insertBefore(script, bodyElement.firstChild);
}

export function injetarAnalytics() {
  Hotjar();
  GTAG();
  Navegg();
  GoogleTagManager();
  Retargeting();
}
